import React from 'react';
import { useTranslation } from 'react-i18next';
import { chooseLanguage, LANGUAGES } from '../i18n';

// FR | EN as a segmented control (styles in ui/ui.css). The choice is kept in localStorage (see chooseLanguage).
function LanguageSwitcher({ className = '' }) {
  const { t, i18n } = useTranslation();
  const current = i18n.resolvedLanguage;
  return (
    <span className={`lang-switcher ${className}`} role="group" aria-label={t('language.label')}>
      {LANGUAGES.map((lng) => (
        <button
          key={lng}
          type="button"
          className={`lang-option${current === lng ? ' lang-option-active' : ''}`}
          aria-pressed={current === lng}
          lang={lng}
          title={t(`language.${lng}`)}
          onClick={() => chooseLanguage(lng)}
        >
          {lng.toUpperCase()}
        </button>
      ))}
    </span>
  );
}

export default LanguageSwitcher;
